module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "报名中"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "报名成功"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.goDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": "https://static.dierqudao.com/images/dinghuoxitong/icon-date.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.create_time_str))])]), _vm._v(" "), (order.status == 1) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                    选择商品\n                                ")]) : (order.status == 2) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                    等待管理员确认订单\n                                ")]) : (order.status == 3) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                    确认金额\n                                ")]) : (order.status == 4) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                    支付订单\n                                ")]) : (order.status == 5) ? _c('div', {
      staticClass: "title-right"
    }, [_vm._v("\n                                    支付成功\n                                ")]) : (order.status == 6) ? _c('div', {
      staticClass: "title-right green"
    }, [_vm._v("\n                                    已发货\n                                ")]) : (order.status == 7) ? _c('div', {
      staticClass: "title-right green"
    }, [_vm._v("\n                                    已安装\n                                ")]) : (order.status == 8) ? _c('div', {
      staticClass: "title-right green"
    }, [_vm._v("\n                                    已完成\n                                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "justify-space-flex row-goods"
    }, [_c('div', {
      staticClass: "row-left flex-start"
    }, [_c('div', {
      staticClass: "goods-detail"
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(order.danwei))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (order.name),
        expression: "order.name"
      }],
      staticClass: "goods-weight gray-light"
    }, [_vm._v("\n                                           联系人：" + _vm._s(order.name) + " " + _vm._s(order.phone) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "row-right"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (order.order_price),
        expression: "order.order_price"
      }],
      staticClass: "goods-price"
    }, [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(order.order_price))])])]), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, [(order.status == 1) ? _c('div', {
      staticClass: "look-order"
    }, [_vm._v("选择商品")]) : (order.status == 3) ? _c('div', {
      staticClass: "look-order"
    }, [_vm._v("确认订单")]) : (order.status == 4) ? _c('div', {
      staticClass: "look-order"
    }, [_vm._v("支付订单")]) : (order.status == 5) ? _c('div', {
      staticClass: "look-order"
    }, [_vm._v("上传合同")]) : (order.status == 6) ? _c('div', {
      staticClass: "look-order"
    }, [_vm._v("确认收货/验收")]) : _vm._e()])])
  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ClubJiansheStep1'
      }),
      expression: "{name:'ClubJiansheStep1'}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("新增建设")])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a530353","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubJiansheList.vue
// module id = 2443
// module chunks = 0